import { useEffect, useState } from "react"

export function usePortalContainer() {
  const [container, setContainer] = useState(null)

  useEffect(() => {
    if (typeof document === "undefined") return

    const root = document.getElementById("tw-root") || document.body
    setContainer(root)
  }, [])

  return container
}
